const loggerManager = {
  init(serverURL) {
    this.serverURL = serverURL;
    this.errorStacks = new Set();

    window.addEventListener('error', ({ error }) => this.log(error));
    window.addEventListener('unhandledrejection', ({ reason }) => this.log(reason));
  },

  log(error) {
    const parseError = ({ name, stack, message }) => ({ name, stack, message });

    const trueError = error || new Error('default error');
    const parsedError = parseError(trueError);

    const errorID = parsedError.stack || parsedError.message;

    if (errorID) {
      if (this.errorStacks.has(errorID)) {
        return;
      }
      this.errorStacks.add(errorID);
    }

    let requestBody;

    try {
      requestBody = JSON.stringify(this.createErrorData(parsedError));
    } catch (err) {
      requestBody = JSON.stringify({
        error: parseError(err),
        originalError: parsedError,
      });
    }

    this.request(requestBody)
      .catch(err => console.error(err)); // prevent recursion
  },

  createErrorData(error) {
    return {
      url: window.location.href,
      error,
    };
  },

  request(body) {
    return fetch(`${this.serverURL}/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res;
        }

        throw new Error(res.status);
      });
  },
};

export default loggerManager;

// const request = {
//   url: string,
//   error: {
//     name: string,
//     message: string,
//     stack: string,
//   },
//   originalError: {
//     name: string,
//     message: string,
//     stack: string,
//   },
// };




// WEBPACK FOOTER //
// ../base/js/managers/logger.js